<template>
  <div class="insight-gem-card" @click="selectGem" :class="{'selected': selected, 'disabled': !selected && disabled}">
    <div class="card-body">
      <img src="/img/gem.svg" class="gem-icon"/>
      <span class="insight-title">{{ insight.title }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: ['insight', 'disabled', 'selected'],
  data () {
    return {
      // selected: false
    }
  },
  methods: {
    selectGem: function () {
      if (!this.disabled) {
        this.$emit('select', this.insight)
        // this.selected = true
      }
    }
  }
}
</script>
